/** Hostnames that may be indexed. Everything else (staging, previews, localhost) gets noindex. */
export const PRODUCTION_HOSTS = ['meliohealthmgmt.co.uk', 'www.meliohealthmgmt.co.uk'];

export function isProductionHost(): boolean {
  if (typeof window === 'undefined') return false;
  return PRODUCTION_HOSTS.includes(window.location.hostname.toLowerCase());
}
